<template>
  <div class="card-order" @click="onclickCard">
    <div style="padding: 12px 40px 0px">
      <b-taglist>
        <b-tag type="is-info">#{{ id }}</b-tag>
        <b-tag type="is-danger"
          ><div>PICKUP AT: {{ startTime }} ({{ duration }})</div></b-tag
        >
        <b-tag v-if="lalamoveTag !== 'LLM'" type="is-success">RIDER: {{ driverName }}</b-tag>
        <b-tag
                    v-if="lalamoveTag === 'LLM'"
                    type="is-warning"
                    class="text-align: center;"
                >
                    RIDER: LALAMOVE
                    <img
                        style="object-fit: contain; height: 20px; vertical-align: middle;"
                        :src="require('@/assets/lalamove.png')"
                        alt="The lalamove Logo"
                    />
        </b-tag>
      </b-taglist>
    </div>
    <div class="columns is-mobile" style="padding: 12px 40px 0px">
      <div class="column is-3">
        <span class="heading">Origin</span>
        <p class="text-box">{{ origin }}</p>
      </div>
      <div class="column is-8">
        <span class="heading">Destination</span>
        <p class="text-box">{{ destination }}</p>
      </div>
      <!-- <div class="column">
        <span class="heading">Time</span>
        <p class>{{ time }}</p>
      </div> -->
      <div class="row" v-if="cancel">
        <b-button
          @click.stop="onCancelOrder"
          type="is-danger"
          style="margin: 5px"
          class="is-small"
          outlined
          icon-right="close"
        />
        <p class="text-box">({{ countdownCancel }})</p>
      </div>
    </div>
    <b-collapse
      :open="description"
      :style="`padding: 0 40px 20px`"
      position="is-bottom"
      aria-id="contentIdForA11y1"
    >
      <div class="columns is-mobile">
        <div class="column is-3">
          <span class="heading">Date</span>
          <p class>{{ date }}</p>
        </div>
        <div class="column is-2">
          <span class="heading">Time</span>
          <p class>{{ time }}</p>
        </div>
        <div class="column is-5">
          <span class="heading">name</span>
          <p class>{{ name }}</p>
        </div>
        <div class="column is-2">
          <span class="heading">price</span>
          <p class>{{ price }}</p>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  props: [
    "id",
    "time",
    "date",
    "driverName",
    "name",
    "price",
    "origin",
    "destination",
    "status",
    "updatedAt",
    "lalamoveTag",
    "destinationLocation",
  ],
  data() {
    return {
      description: false,
      startTime: null,
      duration: null,
      cancel: true,
      countdownCancel: "Loading...",
    };
  },
  async mounted() {
    this.startTime = await this.$store.dispatch("orders/getLogOrderByID", {
      status: "PICKUP",
      id: this.id,
    });
    this.duration = dayjs().to(dayjs(this.startTime));
    const start = new Date(this.startTime);
    this.startTime = dayjs(this.startTime).format("HH:mm");
    const me = this;
    const FIVE_MIN = 5 * 60 * 1000;
    if (this.status === "DELIVERING") {
      this.cancel = false;
    } else {
      if (new Date() - start > FIVE_MIN) {
        this.cancel = false;
      }
      this.setinterval = setInterval(() => {
        if (new Date() - new Date(start) > FIVE_MIN) {
          console.log("Delayed by more than 5 mins");
          this.cancel = false;
          clearInterval(me.setinterval);
        }
        let diff = FIVE_MIN / 1000 - (((Date.now() - start) / 1000) | 0);
        // does the same job as parseInt truncates the float
        let minutes = (diff / 60) | 0;
        let seconds = diff % 60 | 0;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        me.countdownCancel = minutes + ":" + seconds;
      }, 1000);
    }
  },
  methods: {
    onclickCard() {
      const position = {
        origin: this.origin,
        destination: this.destination,
        id: this.id,
        active: this.description,
        driver: this.driverName
      };

      if(this.destinationLocation){
        position.destination = `${this.destinationLocation.lat} ${this.destinationLocation.lng}`;
      }

      this.description = !this.description;
      this.$emit("onclick", position);
    },
    onCancelOrder() {
      this.$emit("oncancelOrder", { id: this.id, date: this.date });
    },
  },
};
</script>

<style scoped>
.card-order {
  border: 1px solid white;
  cursor: pointer;
  color: white;
  /* border-radius: 10px; */
  /* margin: 0.5rem 0.5rem; */
  border-bottom: 1px solid #e8e8e8;
}
.card-order {
  background-color: white;
  color: #2c2a74;
}
.card-order:hover {
  background-color: #f0f0f0;
  color: #2c2a74;
}
.text-title {
  font-size: 13px;
}
.text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.columns:not(:last-child) {
  margin-bottom: 0;
}
p {
  /* font-size: 14px; */
}
</style>
